import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Container } from './Container';
import { PageTransition } from './PageTransition';
import { EmailVerificationBanner } from './EmailVerificationBanner';

interface AppLayoutProps {
  children?: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Skip link for accessibility */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 bg-primary text-primary-foreground px-4 py-2 rounded-md z-50"
      >
        Skip to main content
      </a>

      {/* Header */}
      <Header />
      <EmailVerificationBanner />

      {/* Main content area - full width, no sidebar */}
      <main 
        id="main-content"
        className="flex-1 min-w-0"
        role="main"
        aria-label="Main content"
      >
        <Container size="full" className="h-full">
          <PageTransition>
            {children || <Outlet />}
          </PageTransition>
        </Container>
      </main>
    </div>
  );
}